import BillBatchIcon from '@material-ui/icons/ViewList';

import BankTransferConsolidateList from './BankTransferConsolidateList';

export default {
  list: BankTransferConsolidateList,
  icon: BillBatchIcon,
};
